module.exports = __webpack_public_path__ + "static/media/about-animation-all.c9fa6514.svg";